import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent, setUserId, setUserProperties, Analytics } from "firebase/analytics";
import { getConfig } from "src/config/Config";
import { User } from "src/types/commonTypes";

let analyticsInstance: Analytics | null = null;
let analyticsInitialised = false;

// Firebase Analytics is optional. When the Firebase config is absent (e.g. a
// local dev environment with no .env), initializing it throws
// ("Missing App configuration value: projectId"). Skip init in that case so a
// missing config degrades to no-op analytics instead of crashing the app.
export function getAnalyticsInstance(): Analytics | null {
  if (analyticsInitialised) return analyticsInstance;
  analyticsInitialised = true;

  const config = getConfig();
  if (!config.FIREBASE_CONFIG.projectId) {
    return null;
  }

  const firebaseApp = initializeApp(config.FIREBASE_CONFIG);
  analyticsInstance = getAnalytics(firebaseApp);
  return analyticsInstance;
}

export const logScreenView = (screenName: string) => {
  const analytics = getAnalyticsInstance();
  if (!analytics) return;
  logEvent(analytics, "screen_name", {
    screen_name: screenName
  });
};

export const logUserInteraction = (interactionName: string, details: Record<string, any> = {}) => {
  const analytics = getAnalyticsInstance();
  if (!analytics) return;
  logEvent(analytics, interactionName, details);
};

export const setUserDetail = (user: User, organisationId?: string, callback?: () => void) => {
  const analytics = getAnalyticsInstance();
  if (analytics) {
    setUserId(analytics, user?.id);
    setUserProperties(analytics, {
      ...(organisationId && { organisationId })
    });
  }

  if (callback) {
    callback();
  }
};

export const removeUserDetail = () => {
  const analytics = getAnalyticsInstance();
  if (!analytics) return;
  setUserId(analytics, null);
  setUserProperties(analytics, {
    email: null,
    organisationId: null
  });
};
